document.addEventListener("DOMContentLoaded", function () {
    const wizard = document.getElementById("owd-get-started-wizard");
    if (!wizard) return;

    const form = wizard.closest("form");
    const steps = wizard.querySelectorAll(".owd-wizard__step");
    const badges = wizard.querySelectorAll(".owd-wizard__step-badge");
    const progressFill = document.getElementById("wizard-progress-fill");
    const totalSteps = steps.length;
    let currentStep = 1;

    // Prevent 'Enter' key from submitting the form early
    if (form) {
        form.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
                e.preventDefault();
                const activeStepEl = wizard.querySelector(`.owd-wizard__step[data-step="${currentStep}"]`);
                const nextBtn = activeStepEl ? activeStepEl.querySelector(".js-next-step") : null;
                if (nextBtn && !nextBtn.disabled) {
                    nextBtn.click();
                }
            }
        });
    }

    function updateWizard(targetStep) {
        steps.forEach((step) => {
            const stepNum = parseInt(step.getAttribute("data-step"));
            step.classList.toggle("active", stepNum === targetStep);
        });

        badges.forEach((badge) => {
            const badgeNum = parseInt(badge.getAttribute("data-step-badge"));
            badge.classList.toggle("active", badgeNum === targetStep);
            badge.classList.toggle("completed", badgeNum < targetStep);
        });

        const fillPercentage = (targetStep / totalSteps) * 100;
        if (progressFill) {
            progressFill.style.width = fillPercentage + "%";
        }

        currentStep = targetStep;
        wizard.scrollIntoView({ behavior: "smooth", block: "start" });

        // Re-evaluate button state for new step
        checkStepValidity();
    }

    function isStepValid(stepElement) {
        let isValid = true;

        // 1. Check all required text, email, tel, select, and textarea fields
        const requiredInputs = stepElement.querySelectorAll(
            "input[aria-required='true'], textarea[aria-required='true'], select[aria-required='true']",
        );

        requiredInputs.forEach((input) => {
            if (input.type === "checkbox" || input.type === "radio") return;

            const val = input.value.trim();

            // Check if empty
            if (!val) {
                isValid = false;
            }

            // Check native HTML5 format validity (handles email/tel validation)
            if (val && !input.checkValidity()) {
                isValid = false;
            }
        });

        // 2. Check if CF7 explicitly flagged any field as invalid
        const cf7Invalid = stepElement.querySelectorAll(".wpcf7-not-valid, [aria-invalid='true']");
        if (cf7Invalid.length > 0) {
            isValid = false;
        }

        // 3. Check ONLY radio/checkbox wrapper groups that are required
        const requiredRadioCheckboxGroups = stepElement.querySelectorAll(
            ".wpcf7-checkbox.wpcf7-validates-as-required, .wpcf7-radio.wpcf7-validates-as-required",
        );

        requiredRadioCheckboxGroups.forEach((group) => {
            const checked = group.querySelectorAll("input[type='checkbox']:checked, input[type='radio']:checked");
            if (checked.length === 0) {
                isValid = false;
            }
        });

        return isValid;
    }

    function checkStepValidity() {
        const activeStepEl = wizard.querySelector(`.owd-wizard__step[data-step="${currentStep}"]`);
        if (!activeStepEl) return;

        const nextBtn = activeStepEl.querySelector(".js-next-step");
        if (!nextBtn) return;

        const valid = isStepValid(activeStepEl);

        if (valid) {
            nextBtn.disabled = false;
            nextBtn.removeAttribute("disabled");
            nextBtn.classList.remove("disabled");
        } else {
            nextBtn.disabled = true;
            nextBtn.setAttribute("disabled", "disabled");
            nextBtn.classList.add("disabled");
        }
    }

    // Step navigation event handlers
    wizard.querySelectorAll(".js-next-step").forEach((btn) => {
        btn.addEventListener("click", function (e) {
            if (this.disabled || this.classList.contains("disabled")) {
                e.preventDefault();
                return;
            }
            if (currentStep < totalSteps) {
                updateWizard(currentStep + 1);
            }
        });
    });

    wizard.querySelectorAll(".js-prev-step").forEach((btn) => {
        btn.addEventListener("click", function () {
            if (currentStep > 1) {
                updateWizard(currentStep - 1);
            }
        });
    });

    // Real-time listener: validate on typing and field changes
    wizard.querySelectorAll("input, textarea, select").forEach((element) => {
        ["input", "keyup", "change", "blur"].forEach((eventType) => {
            element.addEventListener(eventType, function () {
                // Remove CF7 invalid flags if the input is currently valid according to browser rules
                if (this.value && this.value.trim().length > 0 && this.checkValidity()) {
                    this.classList.remove("wpcf7-not-valid");
                    this.setAttribute("aria-invalid", "false");
                }
                checkStepValidity();
            });
        });
    });

    // Initial check on DOM load
    checkStepValidity();
});
